import NetaHomeContentComponent from "@/components/neta/NetaHomeContentComponent.vue";
import NetaListAttractionComponent from "@/components/neta/neta-list/NetaListAttractionComponent";
import NetaListEventComponent from "@/components/neta/neta-list/NetaListEventComponent";
import NetaListMultiAttractionComponent from "@/components/neta/neta-list/NetaListMultiAttractionComponent";
import NetaNewAttractionComponent from "@/components/neta/neta-new/NetaNewAttractionComponent.vue";
import NetaNewEventComponent from "@/components/neta/neta-new/NetaNewEventComponent.vue";
import NetaNewMultiAttractionComponent from "@/components/neta/neta-new/NetaNewMultiAttractionComponent.vue";
import NetaListView from "@/views/app-views/NetaListView.vue";
import NetaNewView from "@/views/app-views/NetaNewView.vue";

import NetaAttractionDetailsView from "@/views/app-views/NetaAttractionDetailsView.vue";
import NetaEventDetailsView from "@/views/app-views/NetaEventDetailsView.vue";
import NetaMultiAttractionDetailsView from "@/views/app-views/NetaMultiAttractionDetailsView.vue";

import NetaAttractionBasicDataComponent from "@/components/neta/neta-attraction/basic-data/NetaAttractionBasicDataComponent.vue";
import NetaEventBasicDataComponent from "@/components/neta/neta-event/basic-data/NetaEventBasicDataComponent.vue";
import NetaMultiAttractionBasicDataComponent from "@/components/neta/neta-multi-attraction/basic-data/NetaMultiAttractionBasicDataComponent.vue";
import NetaNewMultiEventComponent from "@/components/neta/neta-new/NetaNewMultiEventComponent.vue";

import OfficeContentComponent from "@/components/neta/office/OfficeContentComponent.vue";
import OfficeExportContentComponent from "@/components/neta/office/OfficeExportContentComponent.vue";
import SpecialistExportContentComponent from "@/components/neta/specialist-export/SpecialistExportContentComponent.vue";
import TmrExportContentComponent from "@/components/neta/tmr-export/TmrExportContentComponent.vue";

import AttractionBasicDataFormComponents from "@/components/neta/neta-attraction/basic-data/FormComponents.js";
import EventBasicDataFormComponents from "@/components/neta/neta-event/basic-data/FormComponents.js";
import MultiAttractionBasicDataFormComponents from "@/components/neta/neta-multi-attraction/basic-data/FormComponents.js";

import BulletinArticleComponent from "@/components/neta/bulletin/BulletinArticleComponent.vue";
import BulletinDocumentsComponent from "@/components/neta/bulletin/BulletinDocumentsComponent.vue";
import BulletinIndexComponent from "@/components/neta/bulletin/BulletinIndexComponent.vue";
import NetaListMultiEventComponent from "@/components/neta/neta-list/NetaListMultiEventComponent.vue";
import MultiEventBasicDataFormComponents from "@/components/neta/neta-multi-event/basic-data/FormComponents.js";
import NetaMultiEventBasicDataComponent from "@/components/neta/neta-multi-event/basic-data/NetaMultiEventBasicDataComponent.vue";
import NtakDashboardContentComponent from "@/components/neta/ntak-dashboard/NtakDashboardContentComponent.vue";
import NetaBulletinView from "@/views/app-views/NetaBulletinView.vue";
import NetaMultiEventDetailsView from "@/views/app-views/NetaMultiEventDetailsView.vue";
import isEmpty from "lodash/isEmpty";
import store from "../../store";

const generateFormChildRoutes = (routePrefix, usedFormComponentNames) => {
  return usedFormComponentNames.map((component) => {
    return {
      path: `${component.name}`,
      name: `${routePrefix}-${component.name}`,
      meta: {
        menuName: component.menuName,
      },
      component,
    };
  });
};

export const routes = {
  path: "/neta",
  name: "neta",
  component: () =>
    import(/* webpackChunkName: "neta" */ "@/views/app-views/AppBaseView.vue"),
  meta: {
    requiresLogin: true,
  },
  redirect: { name: "neta-list" },
  children: [
    {
      path: "home",
      name: "neta-home",
      component: NetaHomeContentComponent,
      redirect: { name: "neta-list" },
    },
    {
      path: "new",
      name: "neta-new",
      component: NetaNewView,
      redirect: { name: "neta-new-attraction" },
      children: [
        {
          path: "attraction",
          name: "neta-new-attraction",
          component: NetaNewAttractionComponent,
        },
        {
          path: "event",
          name: "neta-new-event",
          component: NetaNewEventComponent,
        },
        {
          path: "multi-attraction",
          name: "neta-new-multi-attraction",
          component: NetaNewMultiAttractionComponent,
        },
        {
          path: "multi-event",
          name: "neta-new-multi-event",
          component: NetaNewMultiEventComponent,
        },
      ],
    },
    {
      path: "list",
      name: "neta-list",
      component: NetaListView,
      children: [
        {
          path: "attraction",
          name: "neta-list-attraction",
          component: NetaListAttractionComponent,
          beforeEnter: (to, from, next) => {
            let lastListQueryParams =
              store.state.lastListQueryParams.attraction;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-attraction",
                query: lastListQueryParams,
              });
            } else {
              next();
            }
          },
        },
        {
          path: "event",
          name: "neta-list-event",
          component: NetaListEventComponent,
          beforeEnter: (to, from, next) => {
            let lastListQueryParams = store.state.lastListQueryParams.event;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-event",
                query: lastListQueryParams,
              });
            } else {
              next();
            }
          },
        },
        {
          path: "multi-attraction",
          name: "neta-list-multi-attraction",
          component: NetaListMultiAttractionComponent,
          beforeEnter: (to, from, next) => {
            let lastListQueryParams =
              store.state.lastListQueryParams.multiAttraction;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-multi-attraction",
                query: lastListQueryParams,
              });
            } else {
              next();
            }
          },
        },
        {
          path: "multi-event",
          name: "neta-list-multi-event",
          component: NetaListMultiEventComponent,
          beforeEnter: (to, from, next) => {
            let lastListQueryParams =
              store.state.lastListQueryParams.multiEvent;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-multi-vent",
                query: lastListQueryParams,
              });
            } else {
              next();
            }
          },
        },
      ],

      beforeEnter: (to, from, next) => {
        if (to.name !== "neta-list") {
          next();

          return;
        }

        let lastListQueryParams;

        switch (store.state.lastGroupType) {
          case "event":
            lastListQueryParams = store.state.lastListQueryParams.event;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-event",
                query: lastListQueryParams,
              });
            } else {
              next({
                name: "neta-list-event",
              });
            }

            break;

          case "multiAttraction":
            lastListQueryParams =
              store.state.lastListQueryParams.multiAttraction;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-multi-attraction",
                query: lastListQueryParams,
              });
            } else {
              next({
                name: "neta-list-multi-attraction",
              });
            }

            break;

          case "multiEvent":
            lastListQueryParams = store.state.lastListQueryParams.multiEvent;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-multi-event",
                query: lastListQueryParams,
              });
            } else {
              next({
                name: "neta-list-multi-event",
              });
            }

            break;

          case "attraction":
          default:
            lastListQueryParams = store.state.lastListQueryParams.attraction;

            if (isEmpty(to.query) && !isEmpty(lastListQueryParams)) {
              next({
                name: "neta-list-attraction",
                query: lastListQueryParams,
              });
            } else {
              next({
                name: "neta-list-attraction",
              });
            }

            break;
        }
      },
    },
    {
      path: "office",
      name: "office",
      component: OfficeContentComponent,
      beforeEnter: (to, from, next) => {
        if (store.getters.isRoleAdmin && !store.getters.isRoleViewer) {
          next({ name: "neta-home" });
        } else {
          next();
        }
      },
    },
    {
      path: "tmr-export",
      name: "tmr-export",
      component: TmrExportContentComponent,
      beforeEnter: (to, from, next) => {
        if (!store.getters.isRoleAdmin && !store.getters.isRoleViewer) {
          next({ name: "neta-home" });
        } else {
          next();
        }
      },
    },
    {
      path: "specialist-export",
      name: "specialist-export",
      component: SpecialistExportContentComponent,
      beforeEnter: (to, from, next) => {
        if (!store.getters.isRoleAdmin && !store.getters.isRoleViewer) {
          next({ name: "neta-home" });
        } else {
          next();
        }
      },
    },
    {
      path: "office-export",
      name: "office-export",
      component: OfficeExportContentComponent,
      beforeEnter: (to, from, next) => {
        if (!store.getters.isRoleAdmin && !store.getters.isRoleViewer) {
          next({ name: "neta-home" });
        } else {
          next();
        }
      },
    },
    {
      path: "bulletin",
      name: "neta-bulletin",
      component: NetaBulletinView,
      children: [
        {
          path: "/",
          name: "neta-bulletin-index",
          component: BulletinIndexComponent,
          beforeEnter: (to, from, next) => {
            if (store.getters.isRoleViewer) {
              next({ name: "neta-home" });
            } else {
              next();
            }
          },
        },
        {
          path: "documents",
          name: "neta-bulletin-documents",
          component: BulletinDocumentsComponent,
          beforeEnter: (to, from, next) => {
            if (store.getters.isRoleViewer) {
              next({ name: "neta-home" });
            } else {
              next();
            }
          },
        },
        {
          path: ":slug",
          name: "neta-bulletin-article",
          component: BulletinArticleComponent,
          beforeEnter: (to, from, next) => {
            if (store.getters.isRoleViewer) {
              next({ name: "neta-home" });
            } else {
              next();
            }
          },
        },
      ],
    },
    // {
    //     path: 'bulletin',
    //     name: 'bulletin-index',
    //     component: BulletinIndexComponent,
    //     beforeEnter: (to, from, next) => {
    //         if (store.getters.isRoleViewer) {
    //             next({ name: 'neta-home' })
    //         } else {
    //             next();
    //         }
    //     }
    // },
    // {
    //     path: 'bulletin/:slug',
    //     name: 'bulletin-article',
    //     component: BulletinArticleComponent,
    //     beforeEnter: (to, from, next) => {
    //         if (store.getters.isRoleViewer) {
    //             next({ name: 'neta-home' })
    //         } else {
    //             next();
    //         }
    //     }
    // },
    {
      path: "ntak-dashboard",
      name: "ntak-dashboard",
      component: NtakDashboardContentComponent,
    },
    {
      path: "attractions/:id",
      name: "neta-attraction-details",
      component: NetaAttractionDetailsView,

      redirect: { name: "neta-basic-attraction-data" },
      children: [
        {
          path: "basic",
          name: "neta-basic-attraction-data",
          component: NetaAttractionBasicDataComponent,
          meta: {
            menuName: "Alapadatok",
            attractionType: "basic",
          },
          children: [
            ...generateFormChildRoutes(
              AttractionBasicDataFormComponents.routePrefix,
              AttractionBasicDataFormComponents.usedComponents,
            ),
          ],
        },
      ],
    },
    {
      path: "events/:id",
      name: "neta-event-details",
      component: NetaEventDetailsView,
      redirect: { name: "neta-basic-event-data" },
      children: [
        {
          path: "basic",
          name: "neta-basic-event-data",
          component: NetaEventBasicDataComponent,
          meta: {
            menuName: "Alapadatok",
            attractionType: "basic",
          },
          children: [
            ...generateFormChildRoutes(
              EventBasicDataFormComponents.routePrefix,
              EventBasicDataFormComponents.usedComponents,
            ),
          ],
        },
      ],
    },
    {
      path: "multi-attractions/:id",
      name: "neta-multi-attraction-details",
      component: NetaMultiAttractionDetailsView,
      redirect: { name: "neta-basic-multi-attraction-data" },
      children: [
        {
          path: "basic",
          name: "neta-basic-multi-attraction-data",
          component: NetaMultiAttractionBasicDataComponent,
          meta: {
            menuName: "Alapadatok",
            attractionType: "basic",
          },
          children: [
            ...generateFormChildRoutes(
              MultiAttractionBasicDataFormComponents.routePrefix,
              MultiAttractionBasicDataFormComponents.usedComponents,
            ),
          ],
        },
      ],
    },
    {
      path: "multi-events/:id",
      name: "neta-multi-event-details",
      component: NetaMultiEventDetailsView,
      redirect: { name: "neta-basic-multi-event-data" },
      children: [
        {
          path: "basic",
          name: "neta-basic-multi-event-data",
          component: NetaMultiEventBasicDataComponent,
          meta: {
            menuName: "Alapadatok",
            attractionType: "basic",
          },
          children: [
            ...generateFormChildRoutes(
              MultiEventBasicDataFormComponents.routePrefix,
              MultiEventBasicDataFormComponents.usedComponents,
            ),
          ],
        },
      ],
    },
  ],
};
